import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-additional-property-base',
  templateUrl: './additional-property-base.component.html',
  styleUrls: ['./additional-property-base.component.css']
})
export class AdditionalPropertyBaseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
